import { render, staticRenderFns } from "./FullscreenBtn.vue?vue&type=template&id=206e06da&lang=pug&"
import script from "./FullscreenBtn.vue?vue&type=script&lang=js&"
export * from "./FullscreenBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports